import create from 'zustand';
import { devtools } from 'zustand/middleware';
import { CompleteConfigurationV2 } from '@volkswagen-onehub/car-configuration-feature-service';
import { FinanceProviderState } from '@volkswagen-onehub/finance-integration-service-types';
import { CAFinanceProviderState } from '@vw-marketing/vw-ca-types';
import { VehicleInterface } from '@vw-marketing/vw-ca-types';

interface FinanceStore {
  loadingData: boolean;
  financeData: CAFinanceProviderState | FinanceProviderState<CAFinanceProviderState>;
  configuration: undefined | VehicleInterface | CompleteConfigurationV2;
  initLoad: () => void;
  setData: (data: FinanceProviderState<CAFinanceProviderState>) => void;
  updateFinanceData: <T>(key: string, value: T) => void;
  setConfiguration: (config: VehicleInterface | CompleteConfigurationV2) => void;
};

export const useFinanceStore = create<FinanceStore>()(devtools((set) => {
  return ({
    loadingData: false,
    financeData: {},
    configuration: undefined,
    initLoad: (() => {
      set(() => ({
        loadingData: true
      }));
    }),
    setData: (data) => {
      set((state) => ({
        ...state,
        financeData: data,
        loadingData: false
      }));
    },
    updateFinanceData: (key, value) => {
      set((state) => ({
        ...state,
        financeData: {
          ...state.financeData,
          [key]: value
        }
      }));
    },
    setConfiguration: (config) => {
      set((state) => ({
        ...state,
        configuration: config
      }));
    }
  })
}));
